import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import React, { useState } from "react";
import { PaginationProps } from "antd/es/pagination";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "@/utils/constants";
import { IStockStatisticSonFields, IStockStatisticSonSearch, IStockStatisticSonDetail, stockStatisticService } from "../../stockStatisticService"
export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.pageNum
    }
}

export const useStockStatisticDetailModel = createModel(function () {
    const initSearchParam: IStockStatisticSonSearch = {};
    const initDataSource: IStockStatisticSonDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //查询条件
    const [searchParam, setSearchParam] = useState<IStockStatisticSonSearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IStockStatisticSonDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //
    const [drawerVisible, setDrawerVisible] = useState(false);

    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = async (updateParam: IStockStatisticSonFields) => {
        let newUpdateParam: IStockStatisticSonFields = updateParam;
        setSearchParam({ ...searchParam, ...newUpdateParam })
    }
    const resetSearchParam = (materialCode:string) => {
        setSearchParam({materialCode});
        loadData(initPgCfg, {materialCode});
        setSelectedRowKeys([])
    }
    const loadData = async (page?: ISearchPage, searchValue: IStockStatisticSonSearch = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: page?.pageNum ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,

        }
        let { retData } = await stockStatisticService.detailPage(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        drawerVisible,
        initPgCfg,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setDrawerVisible,
    }
});